export const mainTheme = {
  colors: {
    styleColor1: "#cb287d",
    styleColor2: "#838383",
    styleColor3: "#0a7dc0",
    styleColor4: "rgb(21, 73, 147)",
    subTitleColor: "#cb287d",
  },
};
